import {connect} from 'react-redux';
import {
    getInputValue,
    getError,
    getErrorMessage,
    getDisableCalculateButton,
} from '../../redux/modules/reducer';
import {
    updateInput,
    submitCalculateForm,
    calculateEquivalency,
    invalidateCalculations
} from '../../redux/modules/calculator/calculator';
import Form from './Form';


const mapStateToProps = (state) => ({
    inputValue: getInputValue(state),
    error: getError(state),
    errorMessage: getErrorMessage(state),
    disableCalculateButton: getDisableCalculateButton(state),
});

const mapDispatchToProps = (dispatch) => ({
    onChange(value) {
        dispatch(updateInput(value));
        dispatch(invalidateCalculations());
        dispatch(calculateEquivalency());
    },
    onCalculate() {
        dispatch(submitCalculateForm());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);


/** WEBPACK FOOTER **
 ** ./src/components/Form/index.js
 **/